import { Getters } from 'vuex-smart-module';
import GobalSearchState from './state';

export default class GlobalSearchGetters extends Getters<GobalSearchState> {}
